import { resolveTeamCodeByDomain } from "../service/PublicTeamService";

let cachedTeamCodePromise: Promise<string> | null = null;

const getTeamResolveDomain = () => {
  const { hostname } = document.location;

  if (hostname === "localhost") {
    return process.env.REACT_APP_TEAM_RESOLVE_DOMAIN || hostname;
  }

  return hostname;
};

export const getTeamCodeByHost = async (): Promise<string> => {
  if (!cachedTeamCodePromise) {
    cachedTeamCodePromise = (async () => {
      const domain = getTeamResolveDomain();
      const teamCode = await resolveTeamCodeByDomain(domain);
      return teamCode ?? "";
    })();
  }

  return cachedTeamCodePromise;
};

export default getTeamCodeByHost;
